import { FC } from 'react';
import { Chip, Tooltip } from '@mui/material';
import { KENNZEICHEN_ERKLAERUNG, KENNZEICHEN_TEXT } from './texte';

export type KennzeichenArt =
  | 'pflicht'
  | 'pflichtVerkauf'
  | 'empfohlen'
  | 'optional'
  | 'automatisch'
  | 'admin';

const FARBE: Record<KennzeichenArt, { bg: string; fg: string; border: string }> = {
  pflicht: { bg: '#fdecea', fg: '#a12a1f', border: '#f5c2bd' },
  pflichtVerkauf: { bg: '#fff4e5', fg: '#8a4b00', border: '#ffd8a8' },
  empfohlen: { bg: '#eefaf6', fg: '#1e6b52', border: '#c3ecdd' },
  optional: { bg: '#f3f4f6', fg: '#4b5563', border: '#e5e7eb' },
  automatisch: { bg: '#e8f1fd', fg: '#1d4f91', border: '#c6dbf7' },
  admin: { bg: '#ede9fe', fg: '#4c1d95', border: '#d9d0fb' },
};

/**
 * Kleines Etikett neben einem Feld- oder Abschnittstitel: Pflicht / Optional / Läuft automatisch / Nur Admin.
 * Die Erklärung steht im Tooltip — der Text selbst bleibt kurz, damit er auf einen Blick lesbar ist.
 * `erklaerung` ersetzt den Standardtext, wenn die Fläche kein Webinar ist (Live-Admin: „Pflicht" heißt dort
 * nicht „wird nicht beworben").
 */
const Kennzeichen: FC<{ art: KennzeichenArt; label?: string; erklaerung?: string }> = ({
  art,
  label,
  erklaerung,
}) => {
  const f = FARBE[art];
  return (
    <Tooltip title={erklaerung ?? KENNZEICHEN_ERKLAERUNG[art]} arrow placement="top">
      <Chip
        size="small"
        label={label ?? KENNZEICHEN_TEXT[art]}
        sx={{
          height: 20,
          fontSize: 11,
          fontWeight: 600,
          bgcolor: f.bg,
          color: f.fg,
          border: `1px solid ${f.border}`,
          '& .MuiChip-label': { px: 0.75 },
          cursor: 'help',
        }}
      />
    </Tooltip>
  );
};

export default Kennzeichen;
